import {Component, Injector} from "@angular/core";
import {DatePipe} from "@angular/common";
import {AuthenticationService} from "@mango/authentication";
import {
  ColumnDefinition,
  Filter,
  PagedCollectionComponent,
  SearchableType,
  createColumnDefinitions,
} from "@mango/core";
import {Visitor} from "../visitor";
import {VisitorService} from "../visitor.service";

@Component({
  selector: "app-visitor-collection",
  templateUrl: "./visitor-collection.component.html",
  styleUrls: ["./visitor-collection.component.css"],
  providers: [DatePipe],
})
export class VisitorCollectionComponent extends PagedCollectionComponent<Visitor> {

  columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Visitor>([
    {colDef: "name", prop: (x) => x.name, searchable: SearchableType.String}, // Adding String searchbar on name column
    {colDef: "company", prop: (x) => x.company.name, searchable: SearchableType.String},
    {colDef: "school", prop: (x) => x.school.name, searchable: SearchableType.String},
    {colDef: "other", prop: (x) => x.other, searchable: SearchableType.String},
    {colDef: "meetingPerson", prop: (x) => x.meetingPerson, searchable: SearchableType.String},
    {colDef: "registerTime", prop: (x) => x.registerTime, searchable: SearchableType.Date},
    {colDef: "unregisterTime", prop: (x) => x.unregisterTime, searchable: SearchableType.Date},
  ]);

  displayedColumns = this.columnDefinitions.map((x) => x.colDef);

  constructor(
    public service: VisitorService,
    private authService: AuthenticationService,
    protected filter: Filter<Visitor>,
    injector: Injector,
    private datePipe: DatePipe
  ) {
    super("/frontdesk", injector, Visitor);
  }
}
